import React, {useState, useRef} from 'react';

import {SafeAreaView} from 'react-native-safe-area-context';
import {
  ScrollView,
  Text,
  TextInput,
  TouchableOpacity,
  View,
} from 'react-native';

import useWindowDimensionsSafe from 'src/Modules/Native/useWindowDimensionsSafe';

import StarRating from '../Native/StarRating';
import ModalOmniBar from 'src/Modules/OmniBars/ModalOmniBar';

/////////////////////////////////////////////
/////////////// components
import {BodyText} from 'src/Modules/CommonView';

/////////////////////////////////////////////
/////////////// utils
import isIphoneX from 'src/Utils/IphoneXHelper';
import useParams from '../../Hooks/useParams';
import {navigationRef} from 'src/Nav/navigationHelpers';
import {useUserId} from '../../Hooks/reduxHooks';
const isX = isIphoneX();

const defaultSuperlativeOptions = [
  'Cocktails',
  'Beer',
  'Food',

  'Games',
  'Dates',
  'Clubbing',
  'Hanging Out',

  'Cheap Drinks',
  'Happy Hour',
  'Dancing',
  'Music',
];

////////////// pass in  superlative options, completion action, questions as nav props

const ReviewModal = () => {
  const {width} = useWindowDimensionsSafe();

  const userId = useUserId();
  const {
    star_rating: initialStarRating,
    reviewParams = {},
    reviewSubmit,
    superlativeOptions = defaultSuperlativeOptions,
    displayName = 'This Location',
    primaryRatingText,
    secondaryRatingText,
    superlativesText,
    dining,
    handleBack,
  } = useParams();

  const scrollViewRef = useRef();

  const [star_rating, setStar_rating] = useState(initialStarRating || 4);
  const [star_rating_2, setStar_rating_2] = useState(4);
  const [superlatives, setSuperlatives] = useState([]);
  const [reviewSubmitLoading, setReviewSubmitLoading] = useState(false);
  const [additionalComments, setAdditionalComments] = useState('');
  const [bill_total, setBill_total] = useState('');
  const [group_size, setGroup_size] = useState('');

  const handleReviewSubmit = async () => {
    ////////// handle empty feedback here...
    if (star_rating) {
      setReviewSubmitLoading(true);
      try {
        const params = {
          star_rating,
          star_rating_2,
          user_id: userId,
          superlatives,
          comment: additionalComments,
          bill_total,
          group_size,
          ...reviewParams,
        };

        const response = await reviewSubmit(params);

        response && setReviewSubmitLoading(false);
        navigationRef.goBack(null);
      } catch (error) {
        console.log({error});
        setReviewSubmitLoading(false);
        navigationRef.goBack(null);
      }
    }
  };

  const handleSuperlativePress = (option, alreadySelected) => {
    const nextState = alreadySelected
      ? superlatives.filter((item) => item !== option)
      : [...superlatives, option];

    setSuperlatives(nextState);
  };

  const renderSuperlatives = () => {
    return superlativeOptions?.map?.((option) => {
      let selected = superlatives?.includes?.(option);

      return (
        <TouchableOpacity
          style={{
            alignItems: 'center',
            backgroundColor: selected
              ? global?.color?.teal
              : global?.color?.white1,
            borderRadius: 18,
            height: 36,
            justifyContent: 'center',
            marginHorizontal: 5,
            marginVertical: 5,
            paddingHorizontal: 20,
          }}
          onPress={() => handleSuperlativePress(option, selected)}
          activeOpacity={0.9}
          key={`super_${option}`}>
          <Text
            style={{
              color: selected ? global?.color?.white : global?.color?.gray3,
              fontFamily: global?.font.circular,
              fontSize: 16,
            }}>
            {option}
          </Text>
        </TouchableOpacity>
      );
    });
  };

  return (
    <SafeAreaView
      style={{
        flex: 1,
        backgroundColor: global?.color?.white,
        paddingTop: 30,
      }}>
      <ScrollView
        style={{flex: 1}}
        ref={scrollViewRef}
        showsVerticalScrollIndicator={true}>
        <View
          style={{
            alignItems: 'flex-start',
            paddingTop: 0,
            paddingBottom: 300,
            position: 'relative',
            marginTop: isX ? 40 : 0,
          }}>
          <BodyText
            text={primaryRatingText || `How Did You Enjoy ${displayName}?`}
            textStyle={{
              textAlign: 'left',
              paddingLeft: 5,
              fontSize: 18,
              lineHeight: 20,
              marginLeft: 10,
              marginTop: 10,
              marginBottom: 10,
            }}
          />

          <View style={{width, alignItems: 'center'}}>
            <StarRating
              containerStyle={{marginBottom: 10}}
              disabled={false}
              maxStars={5}
              rating={star_rating}
              onFinishRating={(star_rating) => setStar_rating(star_rating)}
              fullStarColor={global?.color?.yellow}
              emptyStarColor={global?.color?.gray2}
              fractions={0}
            />
          </View>
          {!!secondaryRatingText && (
            <View>
              <BodyText
                text={
                  secondaryRatingText || `How Did You Enjoy ${displayName}?`
                }
                textStyle={{
                  textAlign: 'left',
                  paddingLeft: 5,
                  fontSize: 18,
                  lineHeight: 20,
                  marginLeft: 10,
                  marginTop: 10,
                  marginBottom: 10,
                }}
              />

              <View style={{width, alignItems: 'center'}}>
                <StarRating
                  containerStyle={{marginBottom: 10}}
                  readonly={false}
                  maxStars={5}
                  fractions={0}
                  ratingBackgroundColor={'transparent'}
                  rating={star_rating_2}
                  onFinishRating={(star_rating_2) => {
                    setStar_rating_2(star_rating_2);
                  }}
                  fullStarColor={global?.color?.yellow}
                  emptyStarColor={global?.color?.gray2}
                />
              </View>
            </View>
          )}
          <BodyText
            text={superlativesText || `What Is ${displayName} Best At?`}
            textStyle={{
              textAlign: 'left',
              paddingLeft: 5,
              fontSize: 18,
              lineHeight: 20,
              marginLeft: 10,
              marginTop: 10,
              marginBottom: 10,
            }}
          />
          <View
            style={{
              flexDirection: 'row',
              flexWrap: 'wrap',
              justifyContent: 'center',
              marginHorizontal: 10,
              marginTop: 5,
            }}>
            {renderSuperlatives()}
          </View>
          {!!dining && (
            <View>
              <BodyText
                text={`How Many People Are In Your Party?`}
                textStyle={{
                  textAlign: 'left',
                  paddingLeft: 5,
                  fontSize: 18,
                  lineHeight: 20,
                  marginLeft: 10,
                  marginTop: 10,
                  marginBottom: 10,
                }}
              />
              <View style={{width: width - 20, marginHorizontal: 10}}>
                <TextInput
                  style={{
                    height: 40,
                    fontFamily: global?.font.circular,
                    color: global?.color?.gray3,
                    backgroundColor: global?.color?.white1,
                    flex: 1,
                    borderWidth: 0,
                    paddingHorizontal: 8,
                    paddingVertical: 8,
                    borderRadius: 10,
                  }}
                  allowFontScaling={false}
                  textAlign={'center'}
                  maxLength={3}
                  placeholder={''}
                  value={`${group_size}`}
                  autoCorrect={true}
                  underlineColorAndroid={global?.color?.white1}
                  onChangeText={(group_size) => setGroup_size(group_size)}
                  keyboardType={'numeric'}
                  returnKeyType="done"
                  blurOnSubmit
                />
              </View>

              <BodyText
                text={`How Much Was Your Final Bill?`}
                textStyle={{
                  textAlign: 'left',
                  paddingLeft: 5,
                  fontSize: 18,
                  lineHeight: 20,
                  marginLeft: 10,
                  marginTop: 10,
                  marginBottom: 10,
                  position: 'relative',
                }}
              />
              <View style={{width: width - 20, marginHorizontal: 10}}>
                <TextInput
                  style={{
                    height: 40,
                    fontFamily: global?.font.circular,
                    color: global?.color?.gray3,
                    backgroundColor: global?.color?.white1,
                    flex: 1,
                    borderWidth: 0,
                    paddingHorizontal: 8,
                    paddingVertical: 8,
                    borderRadius: 10,
                  }}
                  allowFontScaling={false}
                  textAlign={'center'}
                  placeholder={''}
                  value={`${bill_total}`}
                  autoCorrect={true}
                  maxLength={6}
                  underlineColorAndroid={global?.color?.white1}
                  onChangeText={(bill_total) => setBill_total(bill_total)}
                  keyboardType={'numeric'}
                  returnKeyType="done"
                  blurOnSubmit
                />
                <BodyText
                  text={'$'}
                  textStyle={{
                    position: 'absolute',
                    left: 5,
                    top: 5,
                  }}
                />
              </View>
            </View>
          )}
          <BodyText
            text={'Leave a review!'}
            textStyle={{
              textAlign: 'left',
              paddingLeft: 5,
              fontSize: 18,
              lineHeight: 20,
              marginLeft: 10,
              marginTop: 10,
              marginBottom: 10,
            }}
          />
          <View style={{width: width - 20, marginHorizontal: 10}}>
            <TextInput
              style={{
                backgroundColor: global?.color?.white1,
                borderRadius: 10,
                borderWidth: 0,
                color: global?.color?.gray3,
                flex: 1,
                fontFamily: global?.font.circular,
                height: 120,
                paddingHorizontal: 15,
                paddingVertical: 15,
              }}
              textAlign={'left'}
              onFocus={() => {
                scrollViewRef.current.scrollToEnd();
              }}
              allowFontScaling={false}
              placeholder={'Optional'}
              value={additionalComments}
              multiline={true}
              autoCorrect={true}
              underlineColorAndroid={global?.color?.white1}
              onChangeText={(additionalComments) => {
                setAdditionalComments(additionalComments);
              }}
              blurOnSubmit
            />
          </View>
        </View>
      </ScrollView>
      <ModalOmniBar
        left={{
          handlePress: () => {
            !!handleBack && handleBack();
            !handleBack && navigationRef.goBack(null);
          },
          icon: 'arrow-left-circle',
          text: 'Back',
        }}
        omniButton={{
          icon: 'check',
          iconLibrary: 'FontAwesome',
          text: 'Submit',
          color: global?.color?.orange,
          handlePress: () => handleReviewSubmit(),
          loading: reviewSubmitLoading,
        }}
      />
    </SafeAreaView>
  );
};

export default ReviewModal;
